import React from "react";
import LectureRow from "./LectureRow";

const LectureTable = ({ lectures, ...rowHandlers }) => {
    return (
        <div className="olp-card">
            <div className="olp-table-wrap">
                <table className="olp-table">
                    <thead>
                        <tr>
                            <th>Ders</th>
                            <th>Tarih</th>
                            <th>Öğretmen</th>
                            <th>Ödevler</th>
                            <th>PDF / Yayın</th>
                            <th>Url Tipi</th>
                            <th>Bilgiler</th>
                            <th>İşlemler</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lectures
                            ? lectures.map((item, index) => (
                                  <LectureRow key={item.Id != null ? item.Id : index} item={item} {...rowHandlers} />
                              ))
                            : null}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default LectureTable;
